
/**
 * 使用 HeyUI 库的 initDict 方法初始化字典数据。
 * 字典数据用于在界面上统一显示和管理各种状态、类型等信息的文字描述。
 *
 * @param {Object} dictConfig - 包含多个字典配置的对象，每个键值对代表一个字典。
 *   - 键：字典的名称，用于在代码中引用该字典。
 *   - 值：一个对象，键为数据的标识，值为该标识对应的显示文本。
 */
HeyUI.initDict({
    // 会计准则字典，0 代表小企业会计准则
    accountingStandards: {0: "小企业会计准则"},
    // 默认单选按钮选项字典，1 代表是，0 代表否
    defaultRadios: {1: "是", 0: "否"},
    // 状态单选按钮选项字典，1 代表正常，0 代表不可用
    statusRadios: {1: "正常", 0: "不可用"},
    // 启用状态单选按钮选项字典，1 代表启用，0 代表不启用
    enableRadios: {1: "启用", 0: "不启用"},
    // 需要状态单选按钮选项字典，1 代表需要，0 代表不需要
    needRadios: {1: "需要", 0: "不需要"},
    // 报表模板类型字典，0 代表普通报表，1 代表资产报表
    reportTemplateType: {0: "普通报表", 1: "资产报表"},
    // 报表模板项类型字典，0 代表资产，1 代表负债，2 代表所有者权益
    reportTemplateItemType: {0: "资产", 1: "负债", 2: "所有者权益"},
    // 访问规则 0 字典，0 代表净发生额，1 代表借方发生额，2 代表贷方发生额
    accessRules0: {0: " 净发生额", 1: "借方发生额", 2: "贷方发生额"},
    // 访问规则 1 字典，3 代表余额，4 代表借方余额，5 代表贷方余额
    accessRules1: {3: "余额", 4: "借方余额", 5: "贷方余额"},
    // 操作符号字典，+ 代表 +，- 代表 -
    operation: {'+': " +", '-': "-"},
    // 报表模板项来源字典，0 代表表外公式，1 代表表内公式
    reportTemplateItemSources: {0: "表外公式", 1: "表内公式"},
    // 增值税纳税人类型单选按钮选项字典，0 代表小规模纳税人
    vatRadios: {0: "小规模纳税人"},
    // 角色字典，Manager 代表账套管理员，Director 代表主管，Making 代表制单人，Cashier 代表出纳，View 代表查看
    roles: {'Manager': "账套管理员", 'Director': "主管", 'Making': "制单人", 'Cashier': "出纳", 'View': "查看"},
    // 凭证模板类型字典，0 代表日常支出，1 代表采购，2 代表销售，3 代表工资，4 代表税金，5 代表折旧和摊销
    voucherTemplateType: {0: "日常支出", 1: "采购", 2: "销售", 3: "工资", 4: "税金", 5: "折旧和摊销"},
    // 行业字典，包含多种行业分类及其对应的名称
    industry: {"0": "IT·通信·电子·互联网", "1": "金融业", "2": "房地产·建筑业", "3": "商业服务", "4": "贸易·批发·零售·租赁业", "5": "文体教育·工艺美术", "6": "生产·加工·制造", "7": "交通·运输·物流·仓储", "8": "服务业", "9": "文化·传媒·娱乐·体育", "10": "能源·矿产·环保", "11": "政府·非盈利机构", "12": "农·林·牧·渔·其他"}
});

